export const eAndODepartments = [6, 17, 20];
